//stolen from p5 because i cant live without these
Math.constrain = function (n, low, high) {
    return Math.max(Math.min(n, high), low);
};

Math.map = function (n, start1, stop1, start2, stop2, withinBounds) {
    const newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) {
        return newval;
    }
    if (start2 < stop2) {
        return Math.constrain(newval, start2, stop2);
    } else {
        return this.constrain(newval, stop2, start2);
    }
};

export function getId(id) {
    let element = document.getElementById(id);
    return element;
}

export function rgbToHsl(r, g, b) {
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;

    if (max == min) {
        h = s = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    return [h * 360, s * 100, l * 100];
}

export function hslToRgb(h, s, l) {
    // Must be fractions of 1
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs((h / 60) % 2 - 1)),
        m = l - c / 2,
        r = 0,
        g = 0,
        b = 0;

    if (0 <= h && h < 60) {
        r = c; g = x; b = 0;
    } else if (60 <= h && h < 120) {
        r = x; g = c; b = 0;
    } else if (120 <= h && h < 180) {
        r = 0; g = c; b = x;
    } else if (180 <= h && h < 240) {
        r = 0; g = x; b = c;
    } else if (240 <= h && h < 300) {
        r = x; g = 0; b = c;
    } else if (300 <= h && h < 360) {
        r = c; g = 0; b = x;
    }
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return [r, g, b];
}

export function hslStyle(hue, sat, lit, alp) {
    if (alp == undefined) {
        return "hsla(" + hue + ", " + sat + "%, " + lit + "%, 1" + ")"
    }
    return "hsla(" + hue + ", " + sat + "%, " + lit + "%, " + alp + ")"
}

export function rem(rem) {
    return parseFloat(rem) * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function boundsMaker(x, y, startX, startY, endW, endH) {
    let newCoord = {
        'x': 0,
        'y': 0
    }
    newCoord.x = Math.constrain(x, startX, endW);
    newCoord.y = Math.constrain(y, startY, endH);
    return newCoord;
}

function boundRect(element) {
    return element.getBoundingClientRect();
}

// crying
let tbl1 = [
    'pld', 'war', 'drk', 'gnb',
    'whm', 'sch', 'ast', 'sge',
    'mnk', 'drg', 'nin', 'sam', 'rpr',
    'brd', 'mch', 'dnc',
    'blm', 'smn', 'rdm', 'blu',
    'crp', 'bsm', 'arm', 'gsm',
    'ltw', 'wvr', 'alc', 'cul',
    'min', 'btn', 'fsh'
];
let tbl2 = [
    'Paladin', 'Warrior', 'Dark Knight', 'Gunbreaker',
    'White Mage', 'Scholar', 'Astrologian', 'Sage',
    'Monk', 'Dragoon', 'Ninja', 'Samurai', 'Reaper',
    'Bard', 'Machinist', 'Dancer',
    'Black Mage', 'Summoner', 'Red Mage', 'Blue Mage',
    'Carpenter', 'Blacksmith', 'Armorer', 'Goldsmith',
    'Leatherworker', 'Weaver', 'Alchemist', 'Culinarian',
    'Miner', 'Botanist', 'Fisher'
];
let tbl3 = [
    'Gladiator', 'Marauder', 'Dark Knight', 'Gunbreaker',
    'Conjurer', 'Arcanist', 'Astrologian', 'Sage',
    'Pugilist', 'Lancer', 'Rogue', 'Samurai', 'Reaper',
    'Archer', 'Machinist', 'Dancer',
    'Thaumaturge', 'Arcanist', 'Red Mage', 'Blue Mage',
    'Carpenter', 'Blacksmith', 'Armorer', 'Goldsmith',
    'Leatherworker', 'Weaver', 'Alchemist', 'Culinarian',
    'Miner', 'Botanist', 'Fisher'];


export function jobLongShort(str, direction) {
    // long to short
    if (direction == 0) {
        let index = tbl2.findIndex((el) => el == str);
        if (index == undefined) {
            index = tbl3.findIndex((el) => el == str);
        }
        return tbl1[index];
    }
    // short to long
    if (direction == 1) {
        let index = tbl1.findIndex((el) => el == str);
        return tbl2[index];
    }
};

export function toCamelCase(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
};

export function toPascalCase(str) {
  return capitalize(toCamelCase(str));
};

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export class mutResizeObserver {
    constructor(callback) {
        this.callback = callback;
        this.target;
        this.prevWidth = 0;
        this.prevHeight = 0;
        this.mut = new ResizeObserver(() => {
            // console.log('mutate');
            if (this.target.clientWidth != this.prevWidth || this.target.clientHeight != this.prevHeight) {
                this.callback.apply(null, [{
                    'target':this.target,
                    'width':this.target.clientWidth,
                    'height':this.target.clientHeight,
                    'prevWidth':this.prevWidth,
                    'prevHeight':this.prevHeight
                }])
            }
            this.prevWidth = this.target.clientWidth;
            this.prevHeight = this.target.clientHeight;
        });
    }

    observe(target) {
        this.target = target;
        this.prevWidth = this.target.clientWidth;
        this.prevHeight = this.target.clientHeight;
        this.mut.observe(this.target);
    }

    disconnect() {
        this.mut.disconnect();
    }
}
